import { subscribeUser } from "@/hooks/useSubscribe";

// Reusable subscription handler
export const handleSubscribe = async (email, setEmail, toast) => {
  if (!email) return;

  try {
    const response = await subscribeUser({ email });

    if (response?.success) {
      toast({
        title: "Subscribed!",
        description: "Thank you for subscribing to our newsletter.",
      });
      setEmail('');
    }
  } catch (error) {
    toast({
      title: "Error",
      description: error?.message || "Failed to subscribe. Please try again later.",
      variant: "destructive",
    });
  }
};
